// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/NavBar/NavBar.css */
.navbar {
  display: flex;
  justify-content: space-between; /* Distribute space between elements */
  align-items: center; /* Align items vertically */
  padding: 0.5rem 2rem;
  background-color: #34495e; /* Dark blue background */
  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Add some shadow for depth */
}

.nav-items-container {
  display: flex;
  justify-content: center; /* Center nav items */
  flex: 1 1; /* Allow nav items to grow and take up available space */
}

.nav-item {
  background-color: #2c3e50; /* Dark blue background */
  border: none; /* Remove border */
  padding: 0.75rem 1.5rem; /* Larger padding for a pill-like shape */
  margin: 0 0.25rem; /* Space out items */
  font-size: 1rem; /* Larger font size */
  color: #ecf0f1; /* Light text */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  border-radius: 20px; /* Rounded corners for pill-like shape */
}

.nav-item:hover {
  background-color: #3498db; /* Light blue on hover */
  transform: translateY(-3px); /* Slight raise effect on hover */
}

.nav-item:active {
  background-color: #2980b9; /* Darker blue when active/clicked */
  transform: translateY(-1px); /* Slightly lowered effect when active/clicked */
}

.active {
  background-color: #1abc9c; /* Some greenish blue for active state */
  color: white;
  transform: scale(1.05); /* Slightly larger active tab */
}

.navbar-search {
  padding-left: 2rem; /* Add some space between nav-items and search bar */
}

.search-input {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 20px; /* Rounded corners for consistency */
  border: none;
  outline: none;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Consistent shadow depth */
}

.search-input:focus {
  box-shadow: 0 2px 5px rgba(0,0,0,0.5); /* Deeper shadow when focused */
}

.date-input-container input[type="date"] {
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 20px; /* Consistent with other inputs */
  border: none;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

/* Responsive styling */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column; /* Stack the items vertically on small screens */
  }

  .nav-item,
  .search-input {
    width: 100%; /* Full width on small screens */
    margin-bottom: 0.5rem; /* Add space between stacked items */
  }

  .navbar-search {
    order: 3; /* Ensure search is last */
  }

  .date-input-container {
    order: 1; /* Ensure date input is first */
    width: 100%; /* Full width on small screens */
    margin-bottom: 0.5rem; /* Add space between stacked items */
  }

  .nav-items-container {
    order: 2; /* Ensure nav items are in the middle */
    width: 100%; /* Full width on small screens */
    justify-content: space-around; /* Distribute space around items */
    flex-wrap: wrap; /* Allow items to wrap */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B,EAAE,sCAAsC;EACtE,mBAAmB,EAAE,2BAA2B;EAChD,oBAAoB;EACpB,yBAAyB,EAAE,yBAAyB;EACpD,qCAAqC,EAAE,8BAA8B;AACvE;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,qBAAqB;EAC9C,SAAO,EAAE,wDAAwD;AACnE;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY,EAAE,kBAAkB;EAChC,uBAAuB,EAAE,yCAAyC;EAClE,iBAAiB,EAAE,oBAAoB;EACvC,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,2DAA2D;EAC3D,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,2BAA2B,EAAE,iCAAiC;AAChE;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,2BAA2B,EAAE,gDAAgD;AAC/E;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,YAAY;EACZ,sBAAsB,EAAE,+BAA+B;AACzD;;AAEA;EACE,kBAAkB,EAAE,oDAAoD;AAC1E;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB,EAAE,oCAAoC;EACzD,YAAY;EACZ,aAAa;EACb,qCAAqC,EAAE,4BAA4B;AACrE;;AAEA;EACE,qCAAqC,EAAE,+BAA+B;AACxE;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB,EAAE,iCAAiC;EACtD,YAAY;EACZ,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB,EAAE,gDAAgD;EAC1E;;EAEA;;IAEE,WAAW,EAAE,gCAAgC;IAC7C,qBAAqB,EAAE,oCAAoC;EAC7D;;EAEA;IACE,QAAQ,EAAE,0BAA0B;EACtC;;EAEA;IACE,QAAQ,EAAE,+BAA+B;IACzC,WAAW,EAAE,gCAAgC;IAC7C,qBAAqB,EAAE,oCAAoC;EAC7D;;EAEA;IACE,QAAQ,EAAE,uCAAuC;IACjD,WAAW,EAAE,gCAAgC;IAC7C,6BAA6B,EAAE,kCAAkC;IACjE,eAAe,EAAE,wBAAwB;EAC3C;AACF","sourcesContent":["/* src/components/NavBar/NavBar.css */\n.navbar {\n  display: flex;\n  justify-content: space-between; /* Distribute space between elements */\n  align-items: center; /* Align items vertically */\n  padding: 0.5rem 2rem;\n  background-color: #34495e; /* Dark blue background */\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Add some shadow for depth */\n}\n\n.nav-items-container {\n  display: flex;\n  justify-content: center; /* Center nav items */\n  flex: 1; /* Allow nav items to grow and take up available space */\n}\n\n.nav-item {\n  background-color: #2c3e50; /* Dark blue background */\n  border: none; /* Remove border */\n  padding: 0.75rem 1.5rem; /* Larger padding for a pill-like shape */\n  margin: 0 0.25rem; /* Space out items */\n  font-size: 1rem; /* Larger font size */\n  color: #ecf0f1; /* Light text */\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  border-radius: 20px; /* Rounded corners for pill-like shape */\n}\n\n.nav-item:hover {\n  background-color: #3498db; /* Light blue on hover */\n  transform: translateY(-3px); /* Slight raise effect on hover */\n}\n\n.nav-item:active {\n  background-color: #2980b9; /* Darker blue when active/clicked */\n  transform: translateY(-1px); /* Slightly lowered effect when active/clicked */\n}\n\n.active {\n  background-color: #1abc9c; /* Some greenish blue for active state */\n  color: white;\n  transform: scale(1.05); /* Slightly larger active tab */\n}\n\n.navbar-search {\n  padding-left: 2rem; /* Add some space between nav-items and search bar */\n}\n\n.search-input {\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border-radius: 20px; /* Rounded corners for consistency */\n  border: none;\n  outline: none;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Consistent shadow depth */\n}\n\n.search-input:focus {\n  box-shadow: 0 2px 5px rgba(0,0,0,0.5); /* Deeper shadow when focused */\n}\n\n.date-input-container input[type=\"date\"] {\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 20px; /* Consistent with other inputs */\n  border: none;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column; /* Stack the items vertically on small screens */\n  }\n\n  .nav-item,\n  .search-input {\n    width: 100%; /* Full width on small screens */\n    margin-bottom: 0.5rem; /* Add space between stacked items */\n  }\n\n  .navbar-search {\n    order: 3; /* Ensure search is last */\n  }\n\n  .date-input-container {\n    order: 1; /* Ensure date input is first */\n    width: 100%; /* Full width on small screens */\n    margin-bottom: 0.5rem; /* Add space between stacked items */\n  }\n\n  .nav-items-container {\n    order: 2; /* Ensure nav items are in the middle */\n    width: 100%; /* Full width on small screens */\n    justify-content: space-around; /* Distribute space around items */\n    flex-wrap: wrap; /* Allow items to wrap */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
